<template>
    <rkm-sidebar :open="open">
        <rkm-sidebar-list class="mt-2">
            <rkm-list-group>
                <rkm-sidebar-list-group-item
                    :active="$route.name && $route.name.includes('dashboard')"
                    :to="{name: 'dashboard'}"
                    icon="home"
                    title="Dashboard"
                />

                <rkm-sidebar-list-group
                    v-for="(modulo) in modulos"
                    v-bind:key="modulo.id"
                >
                    <rkm-sidebar-list-group-item
                        :active="$route.name && $route.name.includes(modulo.identificador)"
                        :icon="modulo.icone"
                        :title="modulo.nome"
                        v-rkm-toggle="`modulo-${modulo.id}`"
                    />
                    
                    <rkm-sidebar-list
                        :id="`modulo-${modulo.id}`"
                        :visible="$route.name && $route.name.split('-').shift() === modulo.identificador"
                        accordion="funcionalidades"
                        sub-group
                    >
                        <rkm-sidebar-list-group
                            v-for="(funcionalidade) in modulo.funcionalidades"
                            v-bind:key="funcionalidade.id"
                        >
                            <rkm-sidebar-list-group-item
                                :active="$route.name && $route.name.includes(funcionalidade.identificador)"
                                :title="funcionalidade.nome"
                                :to="{name: `${modulo.identificador}-${funcionalidade.identificador}`}"
                            />
                        </rkm-sidebar-list-group>
                    </rkm-sidebar-list>
                </rkm-sidebar-list-group>
            </rkm-list-group>
        </rkm-sidebar-list>
    </rkm-sidebar>
</template>

<script>
// Others.
import moment from 'moment'

// Vuex
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({datetime: 'getDatetime'}),
        ...mapGetters({modulos: 'getModulos'}),
    },
    data: () => ({
        others: {moment},
    }),
    props: {
        open: {type: Boolean},
    },
}
</script>